export const GET_INVOICES_TEMPLATE_LIST = "GET_INVOICES_TEMPLATE_LIST";
export const SET_INVOICES_TEMPLATE_LIST = "SET_INVOICES_TEMPLATE_LIST";
export const ADD_INVOICE_TEMPLATE = "ADD_INVOICE_TEMPLATE";
export const UPDATE_INVOICE_TEMPLATE = "UPDATE_INVOICE_TEMPLATE";
export const DELETE_INVOICE_TEMPLATE = "DELETE_INVOICE_TEMPLATE";
export const SET_INVOICE_TEMPLATE_LOADING = "SET_INVOICE_TEMPLATE_LOADING";
